/* Product sharing stays outside the cart form and runs only after a customer gesture. */
(() => {
  if (customElements.get('luw-product-share')) return;

  class LuwProductShare extends HTMLElement {
    connectedCallback() {
      if (this.initialized) {
        this.connectForm();
        return;
      }
      this.initialized = true;
      this.details = this.querySelector('details');
      this.trigger = this.querySelector('summary');
      this.input = this.querySelector('[data-share-input]');
      this.copyButton = this.querySelector('[data-share-copy]');
      this.status = this.querySelector('[data-share-status]');
      if (!this.details || !this.trigger || !this.input || !this.copyButton || !this.status) return;

      this.copyButton.hidden = false;
      this.onFormChange = (event) => {
        if (this.details.open && event.target.closest('[data-product-form]')) this.updateLink();
      };
      this.connectForm();
      this.input.addEventListener('focus', () => this.updateLink());
      this.trigger.addEventListener('click', (event) => this.share(event));
      this.copyButton.addEventListener('click', () => this.copyLink());
      this.details.addEventListener('toggle', () => {
        if (this.details.open) this.updateLink();
      });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.details.open) {
          event.preventDefault();
          this.details.open = false;
          this.trigger.focus();
        }
      });
    }

    connectForm() {
      this.productSection = this.closest('[data-section-id]');
      // Listen after the form's variant handler has updated its hidden variant input.
      this.productSection?.addEventListener('change', this.onFormChange);
    }

    disconnectedCallback() {
      this.productSection?.removeEventListener('change', this.onFormChange);
    }

    updateLink() {
      const url = new URL(this.dataset.shareUrl, window.location.origin);
      // Keep the selected size/color, without preview, tracking, or cart parameters.
      url.search = '';
      url.hash = '';
      const form = this.closest('[data-section-id]')?.querySelector('[data-product-form]');
      const variant = form?.querySelector('[name="id"]')?.value;
      if (variant && /^\d+$/.test(variant)) url.searchParams.set('variant', variant);
      this.input.value = url.href;
      return url.href;
    }

    async share(event) {
      if (this.details.open) return;
      const data = { title: this.dataset.shareTitle, url: this.updateLink() };
      this.status.textContent = '';
      if (typeof navigator.share !== 'function') return;
      if (typeof navigator.canShare === 'function' && !navigator.canShare(data)) return;
      event.preventDefault();
      if (this.sharing) return;
      this.sharing = true;
      try {
        await navigator.share(data);
      } catch (error) {
        if (error.name !== 'AbortError') {
          this.details.open = true;
          this.status.textContent = 'Copy the product link instead.';
          this.copyButton.focus();
        }
      } finally {
        this.sharing = false;
      }
    }

    async copyLink() {
      const url = this.updateLink();
      this.status.textContent = '';
      try {
        if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(url);
        this.status.textContent = 'Link copied.';
      } catch (error) {
        this.input.focus();
        this.input.select();
        this.input.setSelectionRange(0, this.input.value.length);
        this.status.textContent = 'Select and copy this link to share it.';
      }
    }
  }

  customElements.define('luw-product-share', LuwProductShare);
})();
